import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="font-heading text-xl md:text-2xl font-bold text-primary-600">
              东升大舞台
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                分类教程
                <i className={`ri-arrow-down-s-line transition-transform ${isCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isCategoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-background-50 border border-background-200/70 rounded-lg py-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#download"
              className="inline-flex items-center px-5 py-2 bg-primary-500 text-background-50 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-download-line mr-1.5"></i>
              下载App
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link
              to="/"
              className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 cursor-pointer"
            >
              首页
            </Link>
            <div className="border-t border-background-200/70 pt-2">
              <p className="text-xs text-foreground-500 mb-2 px-1">分类教程</p>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="block py-2 text-sm text-foreground-700 hover:text-primary-600 cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <div className="border-t border-background-200/70 pt-2">
              <Link
                to="/about"
                className="block py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 cursor-pointer"
              >
                关于我们
              </Link>
            </div>
            <a
              href="#download"
              className="inline-flex items-center justify-center px-5 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors mt-1"
            >
              <i className="ri-download-line mr-1.5"></i>
              下载App
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}